'use client';

import { type ReactNode, createContext, useContext } from 'react';

export interface DatabaseStats {
  extractedCount: number;
  totalCount: number;
  cenCount: number;
  lastSyncAt: string | null;
}

const DatabaseStatsContext = createContext<DatabaseStats | null>(null);

export function DatabaseStatsProvider({
  children,
  stats,
}: {
  children: ReactNode;
  stats: DatabaseStats;
}) {
  return (
    <DatabaseStatsContext.Provider value={stats}>
      {children}
    </DatabaseStatsContext.Provider>
  );
}

/**
 * Access database stats (extraction counts + last sync time).
 * Returns null when used outside of DatabaseStatsProvider (e.g. marketing pages).
 */
export function useDatabaseStats(): DatabaseStats | null {
  return useContext(DatabaseStatsContext);
}
